import util from './util';

// Creates an array of visited pages stores in session data.
function saveHistory() {
    const url = window.location.href;
    const history = JSON.parse(sessionStorage.getItem('navHistory')) || [];

    // Stops page refreshes from being added
    if (history.length > 1 && history.at(-1) === url) return;

    // Deal with user pressing the browser back button
    const pageExists = history.findIndex((page) => page === url);
    if (pageExists !== -1 && pageExists !== 0) {
        const newHistory = history.slice(0, pageExists + 1);
        sessionStorage.setItem('navHistory', JSON.stringify(newHistory));
        return;
    }

    // Back button should exit surveys not just go back a page.
    if (!copyUrl(url)) return;

    // Store current page.
    history.push(url);
    sessionStorage.setItem('navHistory', JSON.stringify(history));
}

// Get the last visited page
function getBackUrl(history) {
    const curPage = history.pop();

    // This exception is to deal with recruitment mail items - changes url on slide out menu
    if (window.location.href.includes('#item')) {
        return curPage !== `${window.location.origin}${window.location.pathname}`
            ? curPage
            : history.pop();
    }

    // This exception is to deal with timekeeper mail items - pressing back should go back to mail items not back to previous tab
    if (window.location.href.includes('mailkey') && window.location.href.includes('tab=')) {
        return history.pop();
    }

    // In the event of surveys (and other areas), we don't add the current page. So we need to check where to go.
    return curPage !== window.location.href ? curPage : history.pop();
}

function goBack(event) {
    event.preventDefault();

    const history = JSON.parse(sessionStorage.getItem('navHistory')) || [];
    if (history.length > 0) {
        const backUrl = getBackUrl(history);

        sessionStorage.setItem('navHistory', JSON.stringify(history));
        window.location.href = backUrl;
        window.loading.load();
    }

    if (history.length > 10) {
        history.shift();
    }
}

function copyUrl(url) {
    const baseUrl = util.urlBase();
    return ![
        `${baseUrl}apply/`,
        `${baseUrl}personal/surveys/`,
        `${baseUrl}performance/history/`,
        `${baseUrl}performance/plans/`,
        `${baseUrl}recruit/applicant-details/`,
    ].some((excludeUrl) => url.startsWith(excludeUrl));
}

function loadBackButtons() {
    const backButtons = document.querySelectorAll('.btn-back');
    const history = JSON.parse(sessionStorage.getItem('navHistory')) || [];
    backButtons.forEach((backBtn) => {
        if (history.length === 0) backBtn.classList.add('disabled');
        if (history.length === 1 && history[0] === window.location.href)
            backBtn.classList.add('disabled');
        else backBtn.addEventListener('click', (e) => goBack(e));
    });
}

document.addEventListener('DOMContentLoaded', loadBackButtons);
// Sometimes the back button isn't available on load - this checks to make sure back btn is loaded.
document.addEventListener('reloadBackButtons', loadBackButtons);
document.addEventListener('saveNavHistory', saveHistory);

saveHistory();
